import type { RouteRecordRaw } from "vue-router";
import { APP_SETTINGS_HELP_ROUTES as HELP } from "@/Generated/Routes/paths";

const help: RouteRecordRaw[] = [
  {
    ...HELP.root,
    meta: {
      i18nTitle: "settings.help-title",
    },
    component: () => import("@/Views/settings/help/Help.vue"),
  },
  {
    ...HELP.view.root,
    meta: {
      noHeader: true,
    },
    component: () => import("@/Views/settings/help/MobilePageView.vue"),
  },
];

export default help;
